import { chunk } from 'lodash';
import i18next from 'i18next';
import moment from 'moment-timezone';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { generateDefaultSheet } from '@commons/utils/makeXLS';
import { getUserTimezone } from '@commons/utils/date';

import formatProductOrders from '../content/format';
import getContentColumns from '../content/columns';

import formatAggregatedProductOrders from './format';
import getAggregatedColumns from './columns';

const MAX_SHEET_ELEMENT_SIZE = 50_000;

export default (productOrders, { storeName, isCentralExport, currency }) => {
  const formattedProductOrders = formatProductOrders(productOrders);

  const displayCustomerCode = formattedProductOrders.some(({ customerCode }) => customerCode);
  const displayPackagingWeight = formattedProductOrders.some(
    ({ totPackagingWeight }) => totPackagingWeight,
  );

  const aggregatedColumns = getAggregatedColumns({ isCentral: isCentralExport });

  const contentColumns = getContentColumns({
    storeName,
    isCentral: isCentralExport,
    displayCustomerCode,
    displayPackagingWeight,
  });

  const filename = i18next.t('ORDERS.ORDERS.LIST_EXPORT_AGGREGATED_TITLE');
  const aggregatedSheetName = i18next.t(
    'ORDERS.ORDERS.LIST_EXPORT_AGGREGATED_SHEET_AGGREGATED_NAME',
  );
  const contentSheetName = i18next.t('ORDERS.ORDERS.LIST_EXPORT_AGGREGATED_SHEET_CONTENT_NAME');

  const date = moment.tz(getUserTimezone()).format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY);
  const batchProductOrders = chunk(formattedProductOrders, MAX_SHEET_ELEMENT_SIZE);
  const hasManyFiles = batchProductOrders.length > 1;

  return batchProductOrders.map((chunkProductOrders, index) => {
    const appendFileCount = hasManyFiles ? `-${index + 1}` : '';

    const aggregatedProductOrders = formatAggregatedProductOrders(chunkProductOrders);

    const aggregatedSheet = generateDefaultSheet(
      aggregatedSheetName,
      aggregatedColumns,
      aggregatedProductOrders,
      currency,
    );
    const contentSheet = generateDefaultSheet(
      contentSheetName,
      contentColumns,
      chunkProductOrders,
      currency,
    );

    return {
      filename: `${filename}-${date}${appendFileCount}`,
      sheets: [aggregatedSheet, contentSheet],
    };
  });
};
